import { render } from "./PaginationBottom.vue?vue&type=template&id=e799ac5a"
import script from "./PaginationBottom.vue?vue&type=script&lang=js"
export * from "./PaginationBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__